const mutations = {
  setAdmin(state, aprove) {
    state.admin = aprove;
  },
};

export default mutations;
